import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { isFieldForListingType, getDetailCustomFieldValue } from '../../util/fieldHelpers';

import { Heading } from '../../components';

import css from './ListingPage.module.css';

const SectionDetailsMaybe = props => {
  const {
    publicData,
    metadata = {},
    listingFieldConfigs,
    isFieldForCategory,
    intl,
    pickExtendedDataFields,
  } = props;
  if (!publicData || !listingFieldConfigs) {
    return null;
  }

  const defaultPickListingFields = (filteredConfigs, config) => {
    const { key, schemaType, enumOptions, showConfig = {} } = config;

    if (
      key === 'original_price' ||
      key === 'rented_property' ||
      key === 'approval_to_operate' ||
      key === 'business_type' ||
      key === 'featured_on_social' ||
      key === 'liability_insurance' ||
      key === 'start_time_grooming' ||
      key === 'end_time_grooming' ||
      key === 'contact_number' ||
      key === 'contact_country_code' ||
      key === 'phone_country_code' ||
      key === 'emergency_phone_number' ||
      key === 'relationship' ||
      key === 'facility_type' ||
      key === 'facility_type_grooming' ||
      key === 'kennel_type'
    ) {
      return filteredConfigs;
    }

    const listingType = publicData.listingType;

    const isTargetListingType = isFieldForListingType(listingType, config);
    const isTargetCategory = isFieldForCategory(config);

    const { isDetail, label } = showConfig;

    const customLabels = {
      trained_staff: 'Trained Staff & Handlers',
      trained_groomers: 'Trained Groomers',
      petstay_room_count: 'Number of Rooms',
      daycare_room_count: 'Number of Rooms',
      handle_special_needs: 'Special Needs & Anxious Pet Support',
      temperament_assessment: 'Temperament Assessment Process',
      assessment_grooming: 'Pet Assessment Before Grooming',
      custom_feeding: 'Custom feeding schedules',
      sound_proof: 'Soundproof/noise-insulated space',
      vet_availability: 'Vet availability',
      pet_insurance: 'Pet Insurance Coverage',
      odor_management: 'Odor Management Measures',
      waste_management: 'Waste management Measures',
      laundry: 'On-site Laundry for Bedding & Towels',
      balcony_lawn_open_sqft: 'Outdoor Area(sq. ft)',
      drop_off_window: 'Drop-off Time',
      pick_up_window: 'Pick-up Time',
      facility_area: 'Total facility area (in sqft.)',
      pick_drop_option: 'Offer Pick-up/Drop-off',
      havePets: 'Have Pets at Home',
      children: 'Have Children at Home',
    };

    const displayLabel = customLabels[key] || label;

    const publicDataValue = publicData[key];
    const metadataValue = metadata[key];
    const value = publicDataValue != null ? publicDataValue : metadataValue;

    if (isDetail && isTargetListingType && isTargetCategory && typeof value !== 'undefined') {
      const detailValue = getDetailCustomFieldValue(
        enumOptions,
        value,
        schemaType,
        key,
        displayLabel,
        intl,
        'ListingPage'
      );

      return detailValue ? filteredConfigs.concat(detailValue) : filteredConfigs;
    }

    return filteredConfigs;
  };

  const existingListingFields = listingFieldConfigs
    .reduce(pickExtendedDataFields || defaultPickListingFields, [])
    .filter(
      detail =>
        ![
          'contact_number',
          'contact_country_code',
          'phone_country_code',
          'emergency_phone_number',
          'original_price',
          'rented_property',
          'approval_to_operate',
          'business_type',
          'featured_on_social',
          'liability_insurance',
          'start_time_grooming',
          'end_time_grooming',
          'relationship',
          'facility_type',
          'facility_type_grooming',
          'kennel_type',
        ].includes(detail.key)
    );

  return existingListingFields.length > 0 ? (
    <section className={css.sectionDetails} id="about">
      <h4 style={{ marginBottom: '0' }}>
        <FormattedMessage id="ListingPage.detailsTitle" />
      </h4>
      <ul className={css.details}>
        {existingListingFields.map(detail => {
          // if (detail.key == "emergency_phone_number") return;
          return (
            <li
              key={detail.key}
              className={css.detailsRow}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Heading as="h5" style={{ margin: '8px 0px' }}>
                {detail.label}
              </Heading>
              <span className={css.detailsSpan}>{detail.value}</span>
            </li>
          );
        })}
      </ul>
    </section>
  ) : null;
};

export default SectionDetailsMaybe;
